module.exports = __webpack_public_path__ + "static/media/test11_2.a6d0aa3a.png";